import * as api from "api"
import ClassicPopUp from "reusable/popups/ClassicPopUp"
import styled from "styled-components"
import BenefitsForm from "../forms/BenefitsForm"

const StyledWrapper = styled.div`
  text-align: center;
  overflow: auto;
  width: 100%;
`

type PromotionDialogProps = {
  onClose: () => void
  benefit?: api.Benefit
}

const BenefitPopup = ({ onClose, benefit }: PromotionDialogProps) => {
  return (
    <ClassicPopUp
      open={benefit != null}
      onClose={onClose}
      title={benefit?.subject}
      text={benefit?.description}
      narrow
    >
      <StyledWrapper>
        <BenefitsForm benefit={benefit} />
      </StyledWrapper>
    </ClassicPopUp>
  )
}

export default BenefitPopup
